import { BaseError } from './base';

export class MethodNotImplementedError extends BaseError {
  constructor(methodName: string) {
    super({
      cause: null,
      code: 'method_not_implemented_error',
      docsUrl: null,
      name: 'MethodNotImplementedError',
      shortMessage: `This method is not implemented: ${methodName}`,
    });
  }
}
